// `teams`: Swift `Team` (GroundTeam/Models/User.swift). Decoding template `Team(name: "")`
// (GroundTeam/Sync/ResilientDecoding.swift:85).

import type { JsonObject } from '../wire';
import { newId } from '../uuid';
import {
  DATE,
  STRING,
  UUID,
  createModel,
  decodeModel,
  field,
  nowWire,
  type Decoded,
  type FieldMap,
  type Known,
  type Passthrough,
} from './fields';

export interface TeamPayload extends Passthrough {
  id: string;
  name: string;
  managerId?: string;
  parentTeamId?: string;
  colorHex: string;
  createdAt: string;
}

export const TEAM_KEYS = [
  'id',
  'name',
  'managerId',
  'parentTeamId',
  'colorHex',
  'createdAt',
] as const satisfies readonly (keyof Known<TeamPayload>)[];

export const DEFAULT_TEAM_COLOR = '#102A5E';

export const TEAM_FIELDS: FieldMap<TeamPayload> = {
  id: field.strict(UUID),
  name: field.req(STRING, () => ''),
  managerId: field.opt(UUID),
  parentTeamId: field.opt(UUID),
  colorHex: field.req(STRING, () => DEFAULT_TEAM_COLOR),
  createdAt: field.req(DATE, nowWire),
};

export function decodeTeam(raw: JsonObject, envelopeId?: string): Decoded<TeamPayload> {
  return decodeModel(TEAM_FIELDS, raw, {}, envelopeId);
}

export type TeamInit = Partial<Known<TeamPayload>> & { name: string };

export function newTeam(init: TeamInit): TeamPayload {
  return createModel(TEAM_FIELDS, { id: newId(), colorHex: DEFAULT_TEAM_COLOR, createdAt: nowWire() }, init, 'teams');
}
